<script setup>
import { useUserStore } from '~/store/user'

const user = useUserStore()
const localePath = useLocalePath()

const shareUrl = computed(() => {
  const path = localePath(`/sign-up?invitCode=${user.info.sharecode}`)
  if (import.meta.client) {
    return location.origin + path
  }
})
</script>

<template>
  <div class="border border-border rounded-2xl px-4 py-6 box-content">
    <h5 class="font-medium text-lg">
      {{ $t("专属邀请方式") }}
    </h5>
    <div class="flex flex-col gap-4 mt-6">
      <div class="flex items-center justify-between bg-pageTertiary rounded-lg p-4 gap-2">
        <p class="text-textSecondary text-sm whitespace-nowrap">
          {{ $t("邀请码") }}
        </p>
        <div class="flex items-center min-w-0">
          <p class="text-textPrimary text-base break-all mr-2">
            {{ user.info.sharecode }}
          </p>
          <CommonXCopy :value="user.info.sharecode" :text="$t('邀请码复制成功')">
            <template #icon>
              <SvgoCommonCopy2 class="w-4 h-4 ms-2 shrink-0" />
            </template>
          </CommonXCopy>
        </div>
      </div>

      <div class="flex items-center justify-between bg-pageTertiary rounded-lg p-4 gap-2">
        <p class="text-textSecondary text-sm whitespace-nowrap">
          {{ $t("邀请链接") }}
        </p>
        <div class="flex items-center">
          <p class="text-textPrimary text-base break-all mr-2">
            {{ shareUrl }}
          </p>
          <CommonXCopy :value="shareUrl" :text="$t('邀请链接复制成功')">
            <template #icon>
              <SvgoCommonCopy2 class="w-4 h-4 ms-2 shrink-0" />
            </template>
          </CommonXCopy>
        </div>
      </div>
    </div>
  </div>
</template>
